import styled from 'styled-components';

import { ScrollableContainer } from '@web/components/ScrollableContainer/ScrollableContainer';

export const InnerWrapper = styled.div`
  margin: 0 -20px;
  position: relative;

  &::after {
    border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnGray};
    content: '';
    display: block;
    margin: 20px 20px 0;
  }
`;

export const DeleteButton = styled.button`
  all: unset;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  height: 34px;
  opacity: 0.65;
  position: absolute;
  right: 57px;
  top: -75px;
  width: 34px;

  &:hover {
    opacity: 1;
  }
`;

export const Meta = styled.div`
  color: ${({ theme }) => theme.colors.gray};
  display: grid;
  font-size: 12px;
  font-weight: 400;
  gap: 0 10px;
  grid-template:
    'avatar name' auto
    'avatar date' auto
    'recipients recipients' 1fr / min-content 1fr;
  line-height: 19px;
  padding: 0 20px;
`;

export const MetaAvatar = styled.div`
  align-self: center;
  grid-area: avatar;
`;
export const MetaAuthorName = styled.span`
  font-size: 14px;
  font-weight: 600;
  grid-area: name;
`;
export const MetaDate = styled.time`
  grid-area: date;
`;

export const MetaRecipients = styled.span`
  display: flex;
  grid-area: recipients;
  padding-top: 10px;
`;

export const MetaRecipientsTitle = styled.span`
  font-size: 11px;
  font-weight: 700;
  opacity: 0.8;
  text-transform: uppercase;
`;

export const MetaSeenBy = styled.span`
  margin-left: auto;

  & > svg {
    color: ${({ theme }) => theme.colors.iconGray};
    margin-right: 5px;
    vertical-align: text-bottom;
  }
`;

export const RecipientsWrapper = styled.div`
  display: flex;
  flex-flow: column;
  margin: 10px 0 0;
  max-height: 138px;
  position: relative;

  &::after {
    border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnGray};
    content: '';
    display: block;
    margin: 10px 20px 0;
  }
`;

export const ScrollContainer = styled(ScrollableContainer)`
  display: flex;
  flex-flow: column nowrap;
  gap: 20px;
  max-height: 342px;
  // vertical "padding" is 20px
  // scrollbar track has 2px padding
  // we want to have 5px gap on the right side of the scrollbar
  // so 5px - scrollbar track:
  margin-right: 3px;
  margin-top: 20px;
  // and right padding: 20px - scrollbar width (11px) - right gap:
  padding: 0 ${({ shouldApplyFallback }) => (shouldApplyFallback ? '20px' : '6px')} 0 20px;
`;

export const Title = styled.h3`
  all: unset;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
`;
export const Description = styled.div`
  margin-top: -10px;
`;
